<template>
  <div>
    <v-layout>
      <v-dialog v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" lazy>
        <v-toolbar color="blue darken-2" dark>
          <v-icon large left>message</v-icon>
          <v-toolbar-title>Text</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-if="!editTo"
                    v-model="emailText"
                    label="To"
                    readonly
                    hint="Select to edit text addresses"
                    persistent-hint
                    @click.native="editTo = !editTo"
                  ></v-text-field>
                  <v-combobox
                    v-else
                    v-model="editedItem.emails"
                    :items="emailList"
                    label="To"
                    chips
                    multiple
                  >
                    <template slot="selection" slot-scope="data">
                      <v-chip
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        close
                        @input="data.parent.selectItem(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12>
                  <wysiwyg v-model="editedItem.myHTML" @click.native="loadItem()" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              v-if="saving"
              @click.stop="show=false"
            >Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              transition="fade-transition"
              v-if="!saving"
              flat
              @click.stop="show=false"
            >Close</v-btn>
            <v-btn
              color="blue darken-1"
              dark
              transition="fade-transition"
              v-if="saving"
              @click.native="save"
            >Send</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>
</template>

<script>
import Api from '@/services/Api'

export default {
  props: ['visible', 'items', 'selectedItems'],

  data () {
    return {
      saving: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedItem: {
        emails: this.selectedItems,
        from: this.$store.state.user.fullName + ' <' + this.$store.state.user.email + '>',
        replyTo: this.$store.state.user.fullName + ' <' + this.$store.state.user.email + '>',
        cc: [],
        bcc: [],
        subject: '',
        myHTML: ''
      },
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      editTo: false,
      myHTML: '',
      files: []
    }
  },

  created () {
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.editedItem.emails = []
          this.editedItem.cc = []
          this.editedItem.bcc = []
          this.editedItem.subject = ''
          this.editedItem.myHTML = ''
          this.files = []

          this.$emit('close', 'the test')
        }
      }
    }
  },

  watch: {
    visible (val) {
      if (val) {
        this.loadItem()
      }
    },
    editedItem: {
      handler: function (val, oldVal) {
        this.saving = true
      },
      deep: true
    },
    selectedItems: {
      handler: function (val, oldVal) {
        this.editedItem.emails = this.selectedItems
      }
    }
  },

  methods: {
    addFiles () {
      this.$refs.files.click()
    },

    handleFileUploads (e) {
      let uploadedFiles = e.target.files

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i])
      }
    },

    removeFile (key) {
      this.files.splice(key, 1)
    },

    loadItem () {
      this.emailList = this.items
      this.ccList = this.items
      this.bccList = this.items

      if (this.editedItem.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.editedItem.emails.length + ' text addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    async save () {
      let filenames = []

      let formData = new FormData()
      formData.append('to', this.editedItem.emails)
      formData.append('replyTo', this.editedItem.replyTo)
      formData.append('cc', this.editedItem.cc)
      formData.append('bcc', this.editedItem.bcc)
      formData.append('from', this.editedItem.from)
      formData.append('subject', this.editedItem.subject)
      formData.append('text', this.editedItem.myHTML)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        console.log(this.files[i])
        filenames.push(this.files[i].name)
      }
      formData.append('filenames', filenames)

      try {
        const response = await Api().post('emails', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.show = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

input[type="file"]{
  position: absolute;
  top: -500px;
}

span.remove-file{
  color: red;
  cursor: pointer;
  float: right;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/TextForm.vue